
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 7.875a2.625 2.625 0 100 5.25 2.625 2.625 0 000-5.25zm0 3.938a1.313 1.313 0 110-2.626 1.313 1.313 0 010 2.626z","fill":"#2F6BF0"}}),_c('path',{attrs:{"d":"M18.093 12.01l-.906-.52a6.274 6.274 0 000-1.968l.906-.518a1.878 1.878 0 00.689-2.566l-.61-1.057a1.89 1.89 0 00-2.566-.656l-.906.525a6.61 6.61 0 00-1.713-.997V3.17a1.877 1.877 0 00-1.877-1.857H9.89a1.877 1.877 0 00-1.877 1.876v1.018a6.609 6.609 0 00-1.713.997l-.906-.525a1.877 1.877 0 00-2.565.656l-.61 1.09a1.89 1.89 0 00.655 2.566l.906.518a6.274 6.274 0 000 1.969l-.906.518a1.876 1.876 0 00-.656 2.566l.61 1.057a1.89 1.89 0 002.566.689l.906-.525a6.61 6.61 0 001.713.997v1.037a1.877 1.877 0 001.877 1.87h1.22a1.876 1.876 0 001.877-1.876v-1.018a6.608 6.608 0 001.713-.997l.906.525a1.877 1.877 0 002.566-.69l.61-1.056a1.89 1.89 0 00-.69-2.566zm-.453 1.91l-.577 1.056a.564.564 0 01-.768.21l-1.726-.998-.355.322a5.448 5.448 0 01-2.047 1.194l-.46.144v1.97a.565.565 0 01-.564.564H9.89a.565.565 0 01-.565-.565v-1.969l-.459-.144a5.447 5.447 0 01-2.047-1.194l-.355-.322-1.726.998a.57.57 0 01-.768-.21l-.61-1.057a.565.565 0 01.204-.794l1.719-.99-.105-.473a5.25 5.25 0 01.007-2.363l.098-.472-1.72-.952a.564.564 0 01-.203-.774l.61-1.057a.564.564 0 01.768-.21l1.726.998.355-.322a5.447 5.447 0 012.047-1.194l.46-.145V3.202a.564.564 0 01.564-.577h1.22a.565.565 0 01.565.564v1.97l.46.144c.761.242 1.46.65 2.047 1.194l.354.321 1.726-.997a.57.57 0 01.768.21l.61 1.057a.566.566 0 01-.203.787l-1.687.971.105.473a5.242 5.242 0 01-.007 2.362l-.098.473 1.687.971a.564.564 0 01.203.794z","fill":"#2F6BF0"}})])
          )
        }
      }
    